"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "bgn_pcgn",
    description: "BGN/PCGN transliteration schema",
    url: "https://dangry.ru/iuliia/bgn-pcgn/",
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "ё",
        ж: "zh",
        з: "z",
        и: "i",
        й: "y",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "ts",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ъ: "”",
        ы: "y",
        ь: "’",
        э: "e",
        ю: "yu",
        я: "ya",
    },
    prev_mapping: {
        е: "ye",
        ае: "ye",
        ее: "ye",
        ёе: "ye",
        ие: "ye",
        йе: "ye",
        ое: "ye",
        уе: "ye",
        ъе: "ye",
        ые: "ye",
        ье: "ye",
        эе: "ye",
        юе: "ye",
        яе: "ye",
        ё: "yё",
        аё: "yё",
        её: "yё",
        ёё: "yё",
        иё: "yё",
        йё: "yё",
        оё: "yё",
        уё: "yё",
        ъё: "yё",
        ыё: "yё",
        ьё: "yё",
        эё: "yё",
        юё: "yё",
        яё: "yё",
        аы: "·y",
        еы: "·y",
        ёы: "·y",
        иы: "·y",
        оы: "·y",
        уы: "·y",
        ыы: "·y",
        эы: "·y",
        юы: "·y",
        яы: "·y",
        бэ: "·e",
        вэ: "·e",
        гэ: "·e",
        дэ: "·e",
        жэ: "·e",
        зэ: "·e",
        кэ: "·e",
        лэ: "·e",
        мэ: "·e",
        нэ: "·e",
        пэ: "·e",
        рэ: "·e",
        сэ: "·e",
        тэ: "·e",
        фэ: "·e",
        хэ: "·e",
        цэ: "·e",
        чэ: "·e",
        шэ: "·e",
        щэ: "·e",
    },
    next_mapping: {
        йа: "y·",
        йу: "y·",
        йы: "y·",
        йэ: "y·",
        ыа: "y·",
        ыу: "y·",
        ыы: "y·",
        ыэ: "y·",
        тс: "t·",
        шч: "sh·",
    },
    ending_mapping: null,
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Yuliya, s”yesh’ yeshchё etikh myagkikh frantsuzskikh bulok iz Yoshkar-Oly, da vypey altayskogo chayu",
        ],
        [
            "Россия, город Йошкар-Ола, улица Яна Крастыня",
            "Rossiya, gorod Yoshkar-Ola, ulitsa Yana Krastynya",
        ],
        ["Елизово", "Yelizovo"],
        ["Чапаевск", "Chapayevsk"],
        ["Мейеровка", "Meyyerovka"],
        ["Юрьев объезд", "Yur’yev ob”yezd"],
        ["Белкино", "Belkino"],
        ["Ёдва", "Yёdva"],
        ["Змииёвка", "Zmiiyёvka"],
        ["Айёган", "Ayyёgan"],
        ["Воробьёво", "Vorob’yёvo"],
        ["Кебанъёль", "Keban”yёl’"],
        ["Озёрный", "Ozёrnyy"],
        ["Тыайа", "Ty·ay·a"],
        ["Сайылык", "Say·ylyk"],
        ["Ойусардах", "Oy·usardakh"],
        ["Йошкар-Ола", "Yoshkar-Ola"],
        ["Бийск", "Biysk"],
        ["Тыэкан", "Ty·ekan"],
        ["Суык-Су", "Su·yk-Su"],
        ["Тында", "Tynda"],
        ["Улан-Удэ", "Ulan-Ud·e"],
        ["Электрогорск", "Elektrogorsk"],
        ["Руэм", "Ruem"],
        ["Вяртсиля", "Vyart·silya"],
        ["Ташчишма", "Tash·chishma"],
    ],
};
